import {
  removeAccessToken
} from '@/utils/auth'
import router from '@/router'

const user = {
  state: {
    // 用户信息
    info: {},
    authorization: null,
    isOutLimit: false
  },
  // getters: {
  //   authorization: state => {
  //     return state.authorization
  //   }
  // },
  mutations: {
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_AUTHORIZATION: (state, authorization) => {
      state.authorization = authorization
    },
    DESTORY_AUTHORIZATION: (state) => {
      state.authorization = null
      state.info = new Object()
    },
    SET_ISOUTLIMIT: (state, isOutLimit) => {
      state.isOutLimit = isOutLimit
    }
  },

  actions: {
    // 登录
    login({
      commit
    }) {
      return new Promise(resolve => {
        commit('SET_AUTHORIZATION', window.localStorage.getItem('accessToken'))
        resolve()
      })
    },
    // 限制登出操作
    outLimit({
      commit
    }) {
      commit('SET_ISOUTLIMIT', JSON.parse(window.localStorage.getItem('isOutLimit')))
    },
    // 获取用户信息
    SetInfo({
      commit
    }) {
      commit('SET_INFO', JSON.parse(window.localStorage.getItem('userInfo')))
      // return new Promise((resolve, reject) => {
      //   getInfo(state.token).then(response => {
      //     const data = response.data
      //     if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
      //       commit('SET_ROLES', data.roles)
      //     } else {
      //       reject('getInfo: roles must be a non-null array !')
      //     }
      //     commit('SET_NAME', data.name)
      //     commit('SET_AVATAR', data.avatar)
      //     resolve(response)
      //   }).catch(error => {
      //     reject(error)
      //   })
      // })
    },

    /**
     * @description 注销用户并返回登录页面
     * @param {Object} param context
     * @param {Object} param vm {Object} vue 实例
     * @param {Object} param confirm {Boolean} 是否需要确认
     */
    logout({
      dispatch
    }, {
      vm,
      confirm = false
    }) {
      // 判断是否需要确认
      if (confirm) {
        vm.$confirm('注销当前账户吗?', '确认操作', {
            confirmButtonText: '确定注销',
            cancelButtonText: '放弃',
            type: 'warning'
          }).then(() => {
            dispatch('out')
          })
          .catch(() => {
            vm.$message('放弃注销用户')
          })
      }
    },

    /**
     * @description 注销
     */
    async out({
      state,
      commit
    }) {
      // 删除accessToken 并 重定向到登录页
      removeAccessToken().then(() => {
        commit('DESTORY_AUTHORIZATION')
        if (state.isOutLimit) {
          window.location.href = '../autoLogin'
        } else {
          window.location.href = window.location.origin + '/#/home'
        }
      })
    },

    errOut({
      dispatch
    }) {
      dispatch('setSafe', true, {
        root: true
      }).then(() => {
        setTimeout(() => {
          router.push({
            path: '/systemMainten'
          })
        }, 300)
      })
    },
  },
}

export default user